module.exports = __webpack_public_path__ + "img/ASTEKBET.398f082b.svg";